<script>
    import { Drag } from 'vue-drag-drop';
    import {Listeners} from "../../../../constants/listeners";
    export default {
        props: {
            rowData: {
                type: Object,
                required: true
            },
            rowIndex: {
                type: Number
            }
        },
        mounted() {
            this.$emitter.emit(Listeners.KS_TABLE_CLEAR_SELECTED_TO);
        },
        components: {
            Drag
        },
        methods: {
            handleDragStart() {
                this.$emitter.emit(Listeners.CLUSTER_DRAG_START_KEYS, this.rowData.id);
            },
        },
    }
</script>

<template>
<div @dragstart="handleDragStart" draggable="true" style="cursor: move;">
    <i class="fa fa-bars" aria-hidden="true"></i>
</div>
</template>
